import { apiAddress } from "../../config/server";
import { IInvoice } from "../../types/invoice/Invoice";
import { ApiBase } from "./baseApi";

export default class InvoiceApi extends ApiBase {
  static URL = `${apiAddress}/api/invoice/`;

  static getInvoices(): Promise<IInvoice[]> {
    return InvoiceApi.get<IInvoice[]>(this.URL).then(
      (resp) => resp.data.data || [],
    );
  }

  static updateInvoice(
    invoiceId: number,
    invoice: Partial<IInvoice>,
  ): Promise<IInvoice> {
    return InvoiceApi.post<IInvoice>(this.URL + invoiceId, invoice).then(
      (resp) => {
        const invoice = resp.data.data;
        if (!invoice) {
          throw new Error(
            `An unexpected error occurred: ${JSON.stringify(resp.data)}`,
          );
        }
        return invoice;
      },
    );
  }
}
